
















































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// eslint-disable-next-line sort-imports
import { namespace, State } from "vuex-class";
import AppFroala from "@/components/global/AppFroala.vue";
import AppInput from "@/components/global/AppInput.vue";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import { Category } from "@/models/help-center/Category";
import { Entry } from "@/models/help-center/Entry";
import HelpCenterModule from "@/store/modules/help-center";
import { HelpCenterState } from "@/models/store/HelpCenterState";
import { SuccessErrorData } from "@/models/help-center/SuccessErrorData";

const helpCenter = namespace(HelpCenterModule.name);

@Component({
  name: "EntryCreate",
  components: {
    ApplicationLayout,
    AppInput,
    AppFroala,
    ValidationObserver,
    ValidationProvider
  }
})
export default class EntryCreate extends Vue {
  // ===== Store ===== //
  @State("helpCenter") private readonly helpCenter!: HelpCenterState;
  @helpCenter.Action("createEntry") public createEntry!: (entry: Entry) => Promise<void>;
  @helpCenter.Action("getAllEntries") public getAllEntries!: () => Promise<void>;
  @helpCenter.Action("getAllCategories") public getAllCategories!: () => Promise<void>;
  @helpCenter.Action("handleResetCurrentEntry") public handleResetCurrentEntry!: () => void;
  @helpCenter.Getter("categoriesList") public categoriesList!: () => Category[];

  // ===== Methods ===== //
  public handleCancel(): void {
    this.handleResetCurrentEntry();
    this.$router.push({ name: "helpCenterEntries" });
  }
  public async submitForm(): Promise<void> {
    const validated = await (this.$refs.createEntryForm as Vue & { validate: () => boolean }).validate();
    if (!validated) return;

    this.createEntry(this.entry)
      .then(() => {
        this.getAllEntries();
        this.$router.push({ name: "helpCenterEntries" });
      });
  }

  // ===== Computed ===== //
  get categories() {
    return this.categoriesList;
  }
  get entry(): Entry {
    return this.helpCenter.entries.current;
  }
  get error(): SuccessErrorData {
    return this.helpCenter.error ? this.helpCenter.error : { status: false, message: "" };
  }
  get loadingState(): string[] {
    return this.helpCenter.loadingState;
  }
  get success(): SuccessErrorData {
    return this.helpCenter.success ? this.helpCenter.success : { status: false, message: "" };
  }

  // ===== Lifecycle Hook ===== //
  public created(): void {
    this.getAllCategories();
    this.$store.commit("helpCenter/resetCurrentEntry");
  }
}
